import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS } from "@tCentro/theme/design";
import * as React from "react";
import { css } from "styled-components";

export interface AlertMessageIconStyles {
    alertMessageIcon?: InjectableCss;
}

export const alertMessageIconStyles: AlertMessageIconStyles = {
    alertMessageIcon: {
        css: css`
            display: flex;
            justify-content: center;
            width: 24px;
            svg {
                height: 12px !important;
                width: 12px !important;
            }
        `,
    },
};

const styles = alertMessageIconStyles;

const AlertMessageIcon: React.FC = () => {
    return (
        <StyledWrapper {...styles.alertMessageIcon}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.8656 9.77344L6.86639 1.24219C6.48365 0.585938 5.51779 0.585938 5.13248 1.24219L0.135594 9.77344C-0.249016 10.4273 0.230024 11.25 1.00091 11.25H10.9994C11.7672 11.25 12.2476 10.4297 11.8656 9.77344ZM5.4367 3.9375C5.4367 3.62695 5.68865 3.375 5.9992 3.375C6.30974 3.375 6.5617 3.62813 6.5617 3.9375V6.9375C6.5617 7.24805 6.30974 7.5 6.02029 7.5C5.73084 7.5 5.4367 7.24922 5.4367 6.9375V3.9375ZM5.9992 9.75C5.59232 9.75 5.26232 9.42 5.26232 9.01312C5.26232 8.60625 5.59209 8.27625 5.9992 8.27625C6.40631 8.27625 6.73607 8.60625 6.73607 9.01312C6.73514 9.41953 6.40701 9.75 5.9992 9.75Z" fill="#ED0000"/>
            </svg>
        </StyledWrapper>
    );
};

export default React.memo(AlertMessageIcon);
